import { render, staticRenderFns } from "./ImageUploadPage.vue?vue&type=template&id=2e4d89dc&scoped=true&"
import script from "./ImageUploadPage.vue?vue&type=script&lang=js&"
export * from "./ImageUploadPage.vue?vue&type=script&lang=js&"
import style0 from "./ImageUploadPage.vue?vue&type=style&index=0&id=2e4d89dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4d89dc",
  null
  
)

export default component.exports